import styled from 'styled-components'
import { Container } from 'components/atoms'

export const LocalisationContainer = styled(Container)`
  padding: ${ (props) => (props.client ? '10px 10px' : '20px 10px') };

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    padding: ${ (props) => (props.client ? '10px 20px' : '20px 30px') };
  }

  position: relative;
  border-left: ${ (props) =>
    props.client
      ? 'none'
      : `6px solid ${ props.theme.colors['brand-primary-dark'] }` };
  margin: 0 0 35px 0;

  ::after {
    width: 0;
    height: 0;
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-top: 25px solid ${ (props) => props.theme.colors.hellgruen1 };
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
  }

  .localisation-button {
    margin: 0 auto;
    margin-top: 20px;
    width: 245px;
  }

  .localisation-button-small {
    color: ${ (props) => props.theme.colors.weiss };
    font-weight: 700;
    display: inline-block;
    width: auto;
    text-decoration: underline;
  }

  .localisation-close-button {
    background: transparent;
    box-shadow: none;
    padding: 0;
    border: none;
    position: absolute;
    right: 25px;
    top: 20px;
  }

  .close-icon {
    color: ${ (props) => props.theme.colors.weiss };
    opacity: 0.8;

    ::before {
      font-size: 20px;
    }
  }

  .localization-title {
    padding-right: 45px;
    color: ${ (props) => props.theme.colors['text-color-inverse'] };
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;

    @media ${ (props) => props.theme.breakpoints.devices.min.lg } {
      font-size: 22px;
      line-height: 27px;
    }
  }

  .has-location-container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .no-location-container {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .localization-marker {
    color: ${ (props) => props.theme.colors['icon-color-brand-lighter'] };
    font-size: 36px;
    line-height: 36px;
    margin-right: 10px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      font-size: 43px;
      line-height: 43px;
      margin-right: 15px;
    }
  }

  .no-location-copy {
    color: ${ (props) => props.theme.colors['text-color-inverse'] };
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 0;

    @media ${ (props) => props.theme.breakpoints.devices.min.md } {
      font-size: 22px;
      line-height: 27px;
    }
  }

  .has-location-copy {
    margin: 0;
    width: 100%;
    text-align: center;
  }

  .client-name {
    font-weight: bold;
  }
`
